const officeNameInput = document.getElementById('officeName') as HTMLInputElement,
      nameInput = document.getElementById('name') as HTMLInputElement,
      postInput = document.getElementById('post') as HTMLInputElement,
      mailInput = document.getElementById('email') as HTMLInputElement,
      officeAddressInput = document.getElementById('officeAddress') as HTMLInputElement,
      tel1Input = document.getElementById('tel1') as HTMLInputElement,
      tel2Input = document.getElementById('tel2') as HTMLInputElement,
      tel3Input = document.getElementById('tel3') as HTMLInputElement,
      introducerNameInput = document.getElementById('introducerName') as HTMLInputElement,
      contentInput = document.getElementById('content') as HTMLInputElement,

      affiliationRadio: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[name="所属"'),

      participantsNumberRadio: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[name="参加人数"]'),

      socialGatheringRadio: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[name="懇親会への参加"]'),

      socialGatheringNumberRadio: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[name="懇親会への参加人数"]'),

      howToIntroduction = document.getElementById('howToIntroduction') as HTMLInputElement,
      howToIntroductionInput = document.getElementById('howToIntroductionInput') as HTMLInputElement,

      howToMailCheckbox = document.getElementById('howToMailCheckbox') as HTMLInputElement,
      howToMailInput = document.getElementById('howToMailInput') as HTMLInputElement,

      howToSnsCheckbox = document.getElementById('howToSnsCheckbox') as HTMLInputElement,
      howToSnsInput = document.getElementById('howToSnsInput') as HTMLInputElement,

      howKnowInternetSearchCheckbox = document.getElementById('howKnowInternetSearchCheckbox') as HTMLInputElement,
      howKnowInternetSearchInput = document.getElementById('howKnowInternetSearchInput') as HTMLInputElement,

      howToOtherCheckbox = document.getElementById('howToOtherCheckbox') as HTMLInputElement,
      howToOtherInput = document.getElementById('howToOtherInput') as HTMLInputElement,

      officeNameValidMessage = document.getElementById('officeNameValidMessage') as HTMLInputElement,
      nameValidMessage = document.getElementById('nameValidMessage') as HTMLInputElement,
      postValidMessage = document.getElementById('postValidMessage') as HTMLInputElement,
      notMailValidMessage = document.getElementById('notMailValidMessage') as HTMLInputElement,
      officeAddressValidMessage = document.getElementById('officeAddressValidMessage') as HTMLInputElement,
      telValidMessage = document.getElementById('telValidMessage') as HTMLInputElement,
      introducerNameValidMessage = document.getElementById('introducerNameValidMessage') as HTMLInputElement,
      contentValidMessage = document.getElementById('contentValidMessage') as HTMLInputElement,
      affiliationValidMessage = document.getElementById('affiliationValidMessage') as HTMLInputElement,
      participantsNumberValidMessage = document.getElementById('participantsNumberValidMessage') as HTMLInputElement,
      socialGatheringValidMessage = document.getElementById('socialGatheringValidMessage') as HTMLInputElement,
      socialGatheringNumberValidMessage = document.getElementById('socialGatheringNumberValidMessage') as HTMLInputElement,
      howToKnowValidMessage = document.getElementById('howToKnowValidMessage') as HTMLInputElement,



      submitButton = document.getElementById('submitButton') as HTMLButtonElement,
      consentCheckbox = document.getElementById('consentCheckbox') as HTMLInputElement

const onChangeCheckbox = (onChangeElm:HTMLInputElement, targetElm:HTMLInputElement | HTMLButtonElement) => {
    if(onChangeElm) {
        onChangeElm.addEventListener("change", () => {
            if (onChangeElm.checked) {
                targetElm.removeAttribute("disabled")
            } else {
                targetElm.setAttribute("disabled", "true")
            }
        })
    }
}

const checkboxJudgement = (radioElms:NodeListOf<HTMLInputElement>) => {
    let result:boolean = false
    radioElms.forEach((radioElms) => {
        if(radioElms.checked) {
            result = true
        }
    })

    return result
}

const isValidEmail = (email: string): boolean => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
}

onChangeCheckbox(howToIntroduction, howToIntroductionInput)

onChangeCheckbox(howToMailCheckbox, howToMailInput)

onChangeCheckbox(howToSnsCheckbox, howToSnsInput)

onChangeCheckbox(howToOtherCheckbox, howToOtherInput)

// onChangeCheckbox(consentCheckbox, submitButton)

if(howKnowInternetSearchCheckbox) {
    howKnowInternetSearchCheckbox.addEventListener("change", () => {
        if (howKnowInternetSearchCheckbox.checked) {
            howKnowInternetSearchInput.value = 'インターネット検索'
        } else {
            howKnowInternetSearchInput.value = ''
        }
    })
}

if(submitButton) {

    submitButton.addEventListener("click", (event) => {
        let errorFlag:boolean = false
    
        // 事務所名
        if(officeNameInput.value === '') {
            officeNameValidMessage.classList.add('active')
            errorFlag = true
        } else {
            officeNameValidMessage.classList.remove('active')
        }
    
        // 名前
        if(nameInput.value === '') {
            nameValidMessage.classList.add('active')
            errorFlag = true
        } else {
            nameValidMessage.classList.remove('active')
        }
    
        // 役職
        if(postInput.value === '') {
            postValidMessage.classList.add('active')
            errorFlag = true
        } else {
            postValidMessage.classList.remove('active')
        }
    
        // メールアドレス
        if(mailInput.value === '' || !isValidEmail(mailInput.value)) {
            notMailValidMessage.classList.add('active')
            errorFlag = true
        } else {
            notMailValidMessage.classList.remove('active')
        }
    
        // 事務所の住所
        if(officeAddressInput.value === '') {
            officeAddressValidMessage.classList.add('active')
            errorFlag = true
        } else {
            officeAddressValidMessage.classList.remove('active')
        }
    
        // 電話番号
        if(tel1Input.value === '' || tel2Input.value === '' || tel3Input.value === '') {
            telValidMessage.classList.add('active')
            errorFlag = true
        } else {
            telValidMessage.classList.remove('active')
        }
    
        // 紹介者のお名前
        // if(introducerNameInput.value === '') {
        //     introducerNameValidMessage.classList.add('active')
        //     errorFlag = true
        // } else {
        //     introducerNameValidMessage.classList.remove('active')
        // }
    
        // 興味がある内容
        // if(contentInput.value === '') {
        //     contentValidMessage.classList.add('active')
        //     errorFlag = true
        // } else {
        //     contentValidMessage.classList.remove('active')
        // }
    
        // 所属
        const affiliationErr:boolean = checkboxJudgement(affiliationRadio)
    
        if(!affiliationErr) {
            affiliationValidMessage.classList.add('active')
            errorFlag = true
        } else {
            affiliationValidMessage.classList.remove('active')
        }
    
        // 参加人数
        const participantsNumberErr:boolean = checkboxJudgement(participantsNumberRadio)
    
        if(!participantsNumberErr) {
            participantsNumberValidMessage.classList.add('active')
            errorFlag = true
        } else {
            participantsNumberValidMessage.classList.remove('active')
        }
    
        // 懇親会への参加
        const socialGatheringErr:boolean = checkboxJudgement(socialGatheringRadio)
    
        if(!socialGatheringErr) {
            socialGatheringValidMessage.classList.add('active')
            errorFlag = true
        } else {
            socialGatheringValidMessage.classList.remove('active')
        }
    
        // 懇親会の参加人数
        const socialGatheringNumberErr:boolean = checkboxJudgement(socialGatheringNumberRadio)
    
        if(!socialGatheringNumberErr) {
            socialGatheringNumberValidMessage.classList.add('active')
            errorFlag = true
        } else {
            socialGatheringNumberValidMessage.classList.remove('active')
        }
    
        // 当セミナーをどのようにして知りましたか？
        // if(
        //     howToIntroductionInput.value === '' &&
        //     howToMailInput.value === '' &&
        //     howToSnsInput.value === '' &&
        //     howKnowInternetSearchInput.value === '' &&
        //     howToOtherInput.value === ''
        // ) {
        //     howToKnowValidMessage.classList.add('active')
        //     errorFlag = true
        // } else {
        //     howToKnowValidMessage.classList.remove('active')
        // }
    
        if(errorFlag) {
            event.preventDefault()
    
             // ページ内リンクを使用して #contactSection にスクロール
            const contactSection = document.getElementById("contactSection")
            if (contactSection) {
                contactSection.scrollIntoView({ behavior: "smooth" })
            }
        }
    })
}